import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';
import {Router} from '@angular/router';
import {CustomHttp} from '../shared/custom.http';


import 'rxjs/add/operator/toPromise';

import {DPProject} from './model/dp-project';

@Injectable()
export class DPProjectService {

    private projectUrl = '/demandportal/project';  // URL to web api

    constructor(private router: Router, private http: CustomHttp) {
    }


    getProjectsByAccountId(account_id: number) {
        const url = `${this.projectUrl}?accountId=${account_id}`;
        return this.http.get(url, {body: ''});
    }

    getProject(project_id: number) {
        const url = `${this.projectUrl}?projectId=${project_id}`;
        return this.http.get(url, {body: ''});
    }


    createProject(account_id: number, project: DPProject): Promise<DPProject> {
        const url = `${this.projectUrl}?accountId=${account_id}`;
        return this.http.post(url, JSON.stringify(project));
    }

    updateProject(project: DPProject) {
        const url = `${this.projectUrl}?projectId=${project.project_id}`;
        return this.http.put(url, JSON.stringify(project));
    }
}



// WEBPACK FOOTER //
// ./src/app/portalv1/dp-project.service.ts